export default __webpack_public_path__ + "static/media/juice-fruit-product-r-mobile.aeef693f.png";